// Package Imports
import dayjs from 'dayjs';
// Project Imports
import constants from 'core/constants/Constants';

export default function getDateValue(date) {
  const dateValue = dayjs(date)?.format(constants.dateFormatWithHyphen);
  return dateValue;
}

export function getFormattedDate(dateStr) {
  const date = new Date(dateStr);

  // Extract components
  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  // Convert to 12-hour format
  hours %= 12;
  hours = hours || 12; // the hour '0' should be '12'

  // Format minutes to have leading zero if needed
  const minutesFormatted = minutes < 10 ? `0${minutes}` : minutes;

  // Create formatted date string
  const formattedDate = ` ${month} ${day}, ${year} ${String(hours).padStart(
    2,
    '0'
  )}:${minutesFormatted} ${ampm}`;

  return formattedDate;
}

export function getUpdateDate(date) {
  return dayjs(date).format('MMM DD, YYYY');
}

export const renderUpdatedDate = (_, row) => getUpdateDate(row?.updated_at);
